import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/queryClient';
import { ThemeProvider } from './providers/ThemeProvider';
import { ToastProvider } from './providers/ToastProvider';
import { AuthProvider } from './providers/AuthProvider';
import { AppRoutes } from './routes/AppRoutes';
import { AppErrorBoundary } from './components/AppErrorBoundary';

/**
 * Provider order matters:
 *   Router      — so guards and navigation work everywhere
 *   QueryClient — AuthProvider clears the cache on login/logout
 *   Theme       — no data dependencies
 *   Toast       — available to the auth flow
 *   Auth        — the session everything else reads
 */
export function App() {
  return (
    <AppErrorBoundary>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider>
            <ToastProvider>
              <AuthProvider>
                <AppRoutes />
              </AuthProvider>
            </ToastProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </AppErrorBoundary>
  );
}
